import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringIncludes',
  standalone: false
})
export class StringIncludesPipe implements PipeTransform {
  transform(value: string | null, needle: string, lowercaseThem: boolean = false): boolean {
    if (lowercaseThem) {
      return value?.toLowerCase().includes(needle.toLowerCase()) || false;
    }
    return value?.includes(needle) || false;
  }
}
